import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import $ from 'jquery';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class EmployeeSidebar extends Component {
  state = {
    rolesList: [],
    Admin: '',
  };
  componentWillMount() {
    // this.props.getRole();
  }

  componentWillReceiveProps(nextProps) {
    // console.log("data",data);/
  }

  constructor(props) {
    super(props);
    this.state = {
      Tab: 'index',
      SubTab: '',
      MoreTab: '',
      dashboard_menu: false,
      chats: false,
    };
  }

  setActiveTab = (tab, subtab, moretab, toggleTab, e) => {
    this.setState({ Tab: tab, SubTab: subtab, MoreTab: moretab });
    console.log('TT', tab, subtab, moretab, toggleTab);
  };

  componentDidMount() {
    var now_route = '';
    var pageUrl = window.location.pathname.split(/[?#]/)[0];
    now_route = pageUrl.substr(1).replace(/_/g, ' ');
    $('#now_routing').empty();
    if (now_route == '') {
      now_route = 'Dashboard';
    } else {
    }
    $('#now_routing').append(now_route);

    $('.toggle-search').on('click', function () {
      var targetId = $(this).data('target');
      var $searchBar;
      if (targetId) {
        $searchBar = $(targetId);
        $searchBar.toggleClass('open');
      }
    });

    $('.button-menu-mobile').on('click', function (event) {
      event.preventDefault();
      $('body').toggleClass('enlarged');
    });

    $('li.has_sub li').on('click', function (event) {
      $('body').toggleClass('enlarged');
    });
  }
  componentDidUpdate() {
    var now_route = '';
    var pageUrl = window.location.pathname.split(/[?#]/)[0];
    now_route = pageUrl.substr(1).replace('_', ' ');
    $('#now_routing').empty();
    if (now_route == '') {
      now_route = 'Dashboard';
    } else {
    }
    $('#now_routing').append(now_route);
  }
  render() {
    return (
      <div className="left side-menu">
        <div className="topbar-left">
          <div className="">
            <Link to="/" className="logo">
              <img src="/assets/images/logo.webp" height="45" alt="logo" />
            </Link>
          </div>
        </div>

        <div className="sidebar-inner slimscrollleft">
          <PerfectScrollbar>
            <div id="sidebar-menu">
              <ul>
                <li>
                  <Link
                    className={
                      this.state.SubTab === 'dashboard' ? 'active-menu' : ''
                    }
                    onClick={this.setActiveTab.bind(
                      this,
                      'index',
                      'dashboard',
                      ''
                    )}
                    to="/"
                  >
                    <i className="typcn typcn-th-large-outline"></i>Dashboard
                  </Link>
                </li>

                <li>
                  <Link
                    className={
                      this.state.SubTab === 'add timesheet' ? 'active-menu' : ''
                    }
                    onClick={this.setActiveTab.bind(
                      this,
                      'index',
                      'add timesheet',
                      ''
                    )}
                    to="/add-timesheet"
                  >
                    <i className="mdi mdi-alarm-check"></i>Add Timesheet
                  </Link>
                </li>

                <li
                  className={
                    this.state.project
                      ? 'has_sub active-menu nav-active'
                      : 'has_sub'
                  }
                  id="a87ec3a0-83a8-4441-9813-e53faaaa951e"
                >
                  <Link
                    to="#"
                    onClick={() =>
                      this.setState({
                        project: !this.state.project,
                        dashboard_menu: false,
                        monitoring: false,
                        product: false,
                        form_menu: false,
                        chart_menu: false,
                        table_menu: false,
                        icon_menu: false,
                        map_menu: false,
                        auth_menu: false,
                        extra_menu: false,
                        eco_menu: false,
                        emt_menu: false,
                      })
                    }
                    className={
                      this.state.Tab === 'master'
                        ? 'waves-effect active-menu'
                        : 'waves-effect'
                    }
                  >
                    <i className="fa fa-briefcase"></i>{' '}
                    <span>
                      Projects
                      <span className="pull-right">
                        <i className="mdi mdi-chevron-right"></i>
                      </span>{' '}
                    </span>{' '}
                  </Link>
                  <ul
                    className="list-unstyled"
                    style={{ display: this.state.project ? 'block' : 'none' }}
                  >
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'project' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'project', '')}
                        to="/assigned-projects"
                      >
                        Assigned Projects
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={
                          this.state.SubTab === 'Task' ? 'active-menu' : ''
                        }
                        onClick={this.setActiveTab.bind(this, 'Task', '')}
                        to="/assigned-tasks"
                      >
                        Assigned Tasks
                      </Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link
                    className={
                      this.state.SubTab === 'past activities'
                        ? 'active-menu'
                        : ''
                    }
                    onClick={this.setActiveTab.bind(
                      this,
                      'index',
                      'past activities',
                      ''
                    )}
                    to="/past-activities"
                  >
                    <i className="mdi mdi-history"></i>Past Activities
                  </Link>
                </li>

                <li>
                  <Link
                    className={
                      this.state.SubTab === 'app usage' ? 'active-menu' : ''
                    }
                    onClick={this.setActiveTab.bind(
                      this,
                      'index',
                      'app usage',
                      ''
                    )}
                    to="/app-usage"
                  >
                    <i className="fa fa-bar-chart-o"></i>App Usage
                  </Link>
                </li>

                <li>
                  <Link
                    className={
                      this.state.SubTab === 'chats' ? 'active-menu' : ''
                    }
                    onClick={this.setActiveTab.bind(this, 'index', 'chats', '')}
                    to="/chats"
                  >
                    <i className="mdi mdi-message-outline"></i>Chats
                  </Link>
                </li>
              </ul>
            </div>

            <div className="clearfix"></div>
          </PerfectScrollbar>
        </div>
      </div>
    );
  }
}

EmployeeSidebar.propsTypes = {
  // getRole: PropTypes.func.isRequired
};
var mapStateToProps = (state) => ({
  Webtracker: state.Webtracker,
});

export default withRouter(connect(mapStateToProps, {})(EmployeeSidebar));
